import React, { useEffect, useState } from "react";
import { TablePagination } from "../../../components/table";
import { LiveEventList } from "./slice/liveEventAction";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "use-debounce";
import EventItem from '../components/EventItem/EventItem'
import LocalStorage from "../../../hook/LocalStorage";
import {setLoadedEvent, setLoadingEvent, setLoadingContent, liveEventItemList, setDuplicateEvent} from './slice/liveEventSlice'
import ScreenLoader from "../../../components/Loader/ScreenLoader";
import DuplicateForm from "../components/Modal/DuplicateForm";
import DeleteModal from "../components/Modal/DeleteModal";
import MediaDownloadPublicLink from "../components/Modal/MediaDownloadPublicLink";


const TableLive = () => {
	const dispatch = useDispatch();
	const { data, current_page, total, per_page, from, to } = useSelector((state) => state.liveEvent.live_event);

	const { isLoading, loadedEvent, loadingEvent, loadingContent, duplicateEvent } = useSelector(state => state.liveEvent)
	
	const [filterPerPage, setFilterPerPage] = useState(6);
	const [currentPage, setCurrentPage] = useState(1);
	const [searchKeyWord, setSearchKeyWord] = useState("");
	const [searchKeyWordDebounce] = useDebounce(searchKeyWord, 1000);
	const { user } = LocalStorage()

	const handleSearch = (query) => {
		setSearchKeyWord(query);
		setCurrentPage(1);
	};

	const handelFilterPerPage = (perPage) => {
		setCurrentPage(1);
		setFilterPerPage(perPage);
	};

	useEffect(() => {
		const params = {
			per_page: filterPerPage,
			page: currentPage,
			search: searchKeyWordDebounce
		};
		dispatch(LiveEventList(params));
	}, [dispatch, filterPerPage, currentPage, searchKeyWordDebounce]);

	return (
		<>
			<div className="row">
				{!isLoading ?
					data &&
						data.length > 0 ?
						data.map((res) => {
							return (
								<div className="col-md-4" key={res.id}>
									<EventItem 
										targetModalId={"live-modal"}
										removeModalId={"live-modal-remove"}
										mediaDownloadPubliclink={"live-modal-download-link"}
										item={res}
										setDuplicateEvent={setDuplicateEvent}
										eventType={"live"}
										per_page={filterPerPage}
										page={currentPage}
										user_id= {user.id}
										search = {searchKeyWordDebounce}
									/>
								</div>
							);
						})
						:
						<div className="col-12">
							<div className="empty-event">
								<div className="empty-event-content">
									<h4 className="empty-event-title">No Events Found</h4>
								</div>
							</div>
						</div>
					:
					<div className="col-12">
						<div className="empty-event">
							<div className="empty-event-content">
								<div class="spinner-grow text-primary" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
						</div>
					</div>

				}



			{
        loadingEvent && 
          <ScreenLoader loadingContent={loadingContent} loaded={loadedEvent} />
      }

			<DuplicateForm
				modalId={"live-modal"}
				setLoadedEvent={setLoadedEvent}
				setLoadingEvent={setLoadingEvent}
				setLoadingContent={setLoadingContent}
				duplicateEvent={duplicateEvent}
				fetchItemList = {liveEventItemList}
			/>

			<MediaDownloadPublicLink 
				modalId={"live-modal-download-link"}
				selectedUuid={duplicateEvent?.uuid}
			/>

			<DeleteModal
				modalId={"live-modal-remove"}
				selectedItem={duplicateEvent}
				setLoadedEvent={setLoadedEvent}
				setLoadingEvent={setLoadingEvent}
				setLoadingContent={setLoadingContent}
			/>

			</div>
			<TablePagination
				currentPage={current_page}
				total={total}
				perPage={per_page}
				from={from}
				to={to}
				onChange={(page) => setCurrentPage(page)}
			/>
		</>
	);
};

export default TableLive;
